export interface CoverageCode {
  apiName: string;
  labelEn: string;
  labelFr: string;
}

// Coverage codes ordered by display priority as specified in NOVA - Message EOB.csv
export const COVERAGE_CODES: CoverageCode[] = [
  { apiName: '100', labelEn: 'ER Visit', labelFr: 'Visite à l\'urgence' },
  { apiName: '101', labelEn: 'Hospitalization', labelFr: 'Hospitalisation' },
  { apiName: '109', labelEn: 'Physicians Fees Hospitalisation', labelFr: 'Honoraires de médecin lors de l\'hospitalisation' },
  { apiName: '110', labelEn: 'Physicians Fees', labelFr: 'Consultation ou visite médicale' },
  { apiName: '111', labelEn: 'Physiotherapist', labelFr: 'Frais de professionnel: Physiothérapeute' },
  { apiName: '112', labelEn: 'Chiropractor', labelFr: 'Frais de professionnel: Chiropractien' },
  { apiName: '113', labelEn: 'Osteopath', labelFr: 'Frais de professionnel: Ostéopathe' },
  { apiName: '114', labelEn: 'Podiatrist', labelFr: 'Frais de professionnel: Podiatre' },
  { apiName: '115', labelEn: 'Nursing Care', labelFr: 'Soins infirmiers' },
  { apiName: '130', labelEn: 'Medical Appliances', labelFr: 'Appareils médicaux' },
  { apiName: '131', labelEn: 'Laboratory tests or Xrays', labelFr: 'Tests de laboratoires ou rayons X' },
  { apiName: '132', labelEn: 'Magnetic Resonance Imaging (MRI)', labelFr: 'Imagerie par Résonance Magnétique (IRM)' },
  { apiName: '133', labelEn: 'Prescription Drugs', labelFr: 'Médicaments prescrits' },
  { apiName: '140', labelEn: 'Dental Emergency', labelFr: 'Soins dentaires d\'urgence' },
  { apiName: '141', labelEn: 'Dental Care', labelFr: 'Soins dentaires' },
  { apiName: '150', labelEn: 'Ambulance service', labelFr: 'Frais de transport: Ambulance' },
  { apiName: '151', labelEn: 'Accommodation & meals', labelFr: 'Frais accessoires: Repas, etc.' },
  { apiName: '152', labelEn: 'Emergency taxi', labelFr: 'Frais de transport: Taxi' },
  { apiName: '153', labelEn: 'Incidental Expenses', labelFr: 'Frais accessoires' },
  { apiName: '154', labelEn: 'Telephone Fees', labelFr: 'Frais de téléphone' },
  { apiName: '155', labelEn: 'Other Medical Fees', labelFr: 'Autres frais médicaux' },
  { apiName: '157', labelEn: 'Add. transportation SMU-Can', labelFr: 'Transport additionnel SMU-Can' },
  { apiName: '160', labelEn: 'Return of a pet', labelFr: 'Retour d\'un animal de compagnie' },
  { apiName: '161', labelEn: 'Return of Remains', labelFr: 'Retour de la dépouille' },
  { apiName: '163', labelEn: 'Burial Arrangements', labelFr: 'Arrangements funéraires' },
  { apiName: '164', labelEn: 'Repat Air Ambulance', labelFr: 'Rapatriement par ambulance aérienne' },
  { apiName: '165', labelEn: 'Baggage return', labelFr: 'Retour des bagages' },
  { apiName: '166', labelEn: 'Medical Kit', labelFr: 'Trousse médicale' },
  { apiName: '168', labelEn: 'Repat by ambulance', labelFr: 'Rapatriement par ambulance' },
  { apiName: '172', labelEn: 'Repat by aircraft', labelFr: 'Rapatriement par avion' },
  { apiName: '179', labelEn: 'Evacuation', labelFr: 'Évacuation' },

  { apiName: '200', labelEn: 'Pre-paid expenses', labelFr: 'Frais payés d\'avance' },
  { apiName: '201', labelEn: 'Unused portion', labelFr: 'Portion non utilisée' },
  { apiName: '202', labelEn: 'New occupancy charge', labelFr: 'Tarifs d\'occupation' },
  { apiName: '203', labelEn: 'Add. Transportation', labelFr: 'Supplément transport' },
  { apiName: '204', labelEn: 'Vehicle return', labelFr: 'Retour véhicule' },
  { apiName: '205', labelEn: 'Accommodation & meals', labelFr: 'Repas et hébergement' },
  { apiName: '206', labelEn: 'Return of Remains', labelFr: 'Retour dépouille' },
  { apiName: '207', labelEn: 'Emergency Return', labelFr: 'Aller-retour' },
  { apiName: '208', labelEn: 'Other fees', labelFr: 'Frais divers' },
  { apiName: '209', labelEn: 'Travel expenses (C)', labelFr: 'Frais de voyage (C)' },
  { apiName: '210', labelEn: 'Travel expenses (O)', labelFr: 'Frais de voyage (O)' },
  { apiName: '211', labelEn: 'Delayed return fees COVID - CB', labelFr: 'Frais de retard COVID - CB' },

  { apiName: '300', labelEn: 'First Necessity', labelFr: 'Première nécessité' },
  { apiName: '301', labelEn: 'Theft/Loss documents', labelFr: 'Vol/Perte document' },
  { apiName: '302', labelEn: 'Theft/Loss misc', labelFr: 'Vol/Perte divers' },
  { apiName: '303', labelEn: 'Theft/Loss of fur', labelFr: 'Vol/Perte fourrure' },
  { apiName: '304', labelEn: 'Theft/Loss Jewellery', labelFr: 'Vol/Perte bijoux' },
  { apiName: '305', labelEn: 'Theft/Loss photo', labelFr: 'Vol/Perte photo' },
  { apiName: '306', labelEn: 'Bag Repair', labelFr: 'Réparation valise' },
  { apiName: '307', labelEn: 'Other fees baggage', labelFr: 'Autre frais bagages' },
];

// Helper function to get coverage codes for dropdown
export const getCoverageCodeOptions = (language: string): Array<{ value: string, label: string }> => {
  const isFrench = language.startsWith('fr');

  const codeOptions = COVERAGE_CODES.map(code => ({
    value: code.apiName,
    label: isFrench ? (code.labelFr || code.labelEn) : code.labelEn
  }));

  return codeOptions;
};

// Helper function to get label by API name
export const getCoverageCodeLabel = (apiName: string, language: string): string => {
  const isFrench = language.startsWith('fr');
  const code = COVERAGE_CODES.find(c => c.apiName === apiName);

  if (!code) return isFrench ? 'Prestation' : 'Benefit';

  return isFrench ? (code.labelFr || code.labelEn) : code.labelEn;
};
